var _excluded = ["scope", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { Slot as e } from "@radix-ui/react-slot";
import { useComposedRefs as r } from "@radix-ui/react-compose-refs";
import { createContextScope as t } from "@radix-ui/react-context";
import o from "react";
export function createCollection(c) {
  var n = c + "CollectionProvider",
      _t = t(n),
      _t2 = _slicedToArray(_t, 2),
      l = _t2[0],
      i = _t2[1],
      _l = l(n, {
    collectionRef: {
      current: null
    },
    itemMap: new Map()
  }),
      _l2 = _slicedToArray(_l, 2),
      f = _l2[0],
      a = _l2[1],
      u = function u(e) {
    var r = e.scope,
        t = e.children,
        c = o.useRef(null),
        n = o.useRef(new Map()).current;
    /*#__PURE__*/

    /*#__PURE__*/
    return /*#__PURE__*/o.createElement(f, {
      scope: r,
      itemMap: n,
      collectionRef: c
    }, t);
  },
      m = c + "CollectionSlot",
      s = /*#__PURE__*/o.forwardRef(function (t, c) {
    var n = t.scope,
        l = t.children,
        i = a(m, n),
        f = r(c, i.collectionRef);
    /*#__PURE__*/

    /*#__PURE__*/
    return /*#__PURE__*/o.createElement(e, {
      ref: f
    }, l);
  }),
      p = c + "CollectionItemSlot",
      d = "data-radix-collection-item",
      R = /*#__PURE__*/o.forwardRef(function (t, c) {
    var _o$createElement;

    var n = t.scope,
        l = t.children,
        i = _objectWithoutProperties(t, _excluded),
        f = o.useRef(null),
        u = r(c, f),
        m = a(p, n);

    return o.useEffect(function () {
      return m.itemMap.set(f, _objectSpread({
        ref: f
      }, i)), function () {
        m.itemMap["delete"](f);
      };
    }), /*#__PURE__*/o.createElement(e, (_o$createElement = {}, _defineProperty(_o$createElement, d, ""), _defineProperty(_o$createElement, "ref", u), _o$createElement), l);
  });

  return [{
    Provider: u,
    Slot: s,
    ItemSlot: R
  }, function (e) {
    var r = a(c + "CollectionConsumer", e);
    return o.useCallback(function () {
      var e = r.collectionRef.current;
      if (!e) return [];
      var t = Array.from(e.querySelectorAll("[".concat(d, "]")));
      return Array.from(r.itemMap.values()).sort(function (e, r) {
        return t.indexOf(e.ref.current) - t.indexOf(r.ref.current);
      });
    }, [r.collectionRef, r.itemMap]);
  }, i];
}